module.exports = __webpack_public_path__ + "img/graph-high.b707fccf.svg";